"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _pluralize = _interopRequireDefault(require("pluralize"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _zIndex = _interopRequireDefault(require("../../../constants/z-index"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _pad = _interopRequireDefault(require("../../../utils/pad"));

var _Input = _interopRequireDefault(require("../../Input"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _TimeOverlay = _interopRequireDefault(require("./TimeOverlay"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", " !important;\n\tmargin-bottom: 0px !important;\n\t", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", " !important;\n\tborder: ", " solid ", ";\n\tborder-radius: ", ";\n\tmargin-top: -", ";\n\tpadding: ", ";\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\t", ";\n\tz-index: ", ";\n\n\t@media (min-width: ", ") {\n\t\tposition: absolute;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

_pluralize.default.addIrregularRule('hr', 'hrs');

_pluralize.default.addIrregularRule('min', 'mins');

var borderColorMixin = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.overlayOpen && "border-color: " + _colors.default.primary + " !important";
});

var OverlayContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.width;
}, _vars.default.borderWidth, _colors.default.grey, _vars.default.borderRadius, _vars.default.borderWidth, _spacing.default.s2, _colors.default.white, _vars.default.boxShadow, borderColorMixin, _zIndex.default.OVERLAY, _breakpoints.default.tablet);

OverlayContainer.displayName = 'OverlayContainer';
var TimePickerInput = (0, _styledComponents.default)(_Input.default)(_templateObject3(), function (props) {
  return props.width;
}, borderColorMixin);
TimePickerInput.displayName = 'TimePickerInput';

var TimePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TimePicker, _React$Component);

  function TimePicker() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      overlayOpen: false
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = TimePicker.prototype;

  _proto.apply = function apply(time) {
    this.toggleOverlay();
    this.props.onTimeSet(time);
  };

  _proto.openOverlayIfNotOpen = function openOverlayIfNotOpen() {
    var overlayOpen = this.state.overlayOpen;

    if (!overlayOpen) {
      this.setState({
        overlayOpen: true
      });
    }
  };

  _proto.toggleOverlay = function toggleOverlay() {
    var toggle = this.state.overlayOpen;
    this.setState({
      overlayOpen: !toggle
    });
  };

  _proto.handleClickOutside = function handleClickOutside() {
    this.setState({
      overlayOpen: false
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        stepMinutes = _this$props.stepMinutes,
        minMinutes = _this$props.minMinutes,
        maxMinutes = _this$props.maxMinutes,
        stepHours = _this$props.stepHours,
        minHours = _this$props.minHours,
        maxHours = _this$props.maxHours,
        isDurationPicker = _this$props.isDurationPicker,
        isDurationMinsOnly = _this$props.isDurationMinsOnly,
        tickOverEnabled = _this$props.tickOverEnabled,
        overlayWidth = _this$props.overlayWidth,
        inputWidth = _this$props.inputWidth,
        GA = _this$props.GA,
        hour = _this$props.hour,
        minute = _this$props.minute,
        name = _this$props.name,
        minTime = _this$props.minTime,
        maxTime = _this$props.maxTime,
        id = _this$props.id;
    var overlayOpen = this.state.overlayOpen;
    var inputValue;

    if (isDurationPicker && isDurationMinsOnly) {
      inputValue = minute + " " + (0, _pluralize.default)('min', minute);
    } else if (isDurationPicker) {
      inputValue = hour + " " + (0, _pluralize.default)('hr', hour) + " " + minute + " " + (0, _pluralize.default)('min', minute);
    } else {
      var minutesPadding = maxMinutes.toString().length;
      var hoursPadding = maxHours.toString().length;
      inputValue = (0, _pad.default)(hour, hoursPadding) + ":" + (0, _pad.default)(minute, minutesPadding);
    }

    return _react.default.createElement("div", {
      "data-e2e": "time-picker-" + id
    }, _react.default.createElement(TimePickerInput, {
      width: inputWidth,
      value: inputValue,
      onFocus: this.openOverlayIfNotOpen,
      readOnly: true,
      overlayOpen: overlayOpen,
      "data-e2e": name
    }), overlayOpen && _react.default.createElement(OverlayContainer, {
      width: overlayWidth,
      overlayOpen: overlayOpen
    }, _react.default.createElement(_TimeOverlay.default, {
      GA: GA,
      minute: minute,
      stepMinutes: stepMinutes,
      minMinutes: minMinutes,
      maxMinutes: maxMinutes,
      hour: hour,
      stepHours: stepHours,
      minHours: minHours,
      maxHours: maxHours,
      tickOverEnabled: tickOverEnabled,
      onApply: this.apply,
      onCancel: this.toggleOverlay,
      isDurationPicker: isDurationPicker,
      isDurationMinsOnly: isDurationMinsOnly,
      minTime: minTime,
      maxTime: maxTime
    })));
  };

  return TimePicker;
}(_react.default.Component);

TimePicker.displayName = 'TimePicker';
TimePicker.propTypes = {
  GA: (0, _propTypes.shape)({
    action: _propTypes.string,
    category: _propTypes.string
  }),
  minute: _propTypes.number.isRequired,
  stepMinutes: _propTypes.number,

  /** only respected if using MinutesOnlyDurationPicker, should be in increments of stepMinutes */
  minMinutes: _propTypes.number,

  /** only respected if using MinutesOnlyDurationPicker, should be in increments of stepMinutes */
  maxMinutes: _propTypes.number,
  hour: _propTypes.number.isRequired,
  stepHours: _propTypes.number,
  minHours: _propTypes.number,
  maxHours: _propTypes.number,
  tickOverEnabled: _propTypes.bool,
  isDurationPicker: _propTypes.bool,
  isDurationMinsOnly: _propTypes.bool,
  overlayWidth: _propTypes.string,
  inputWidth: _propTypes.string,
  onTimeSet: _propTypes.func.isRequired,
  name: _propTypes.string,
  minTime: (0, _propTypes.shape)({
    hours: _propTypes.number,
    minutes: _propTypes.number
  }),
  maxTime: (0, _propTypes.shape)({
    hours: _propTypes.number,
    minutes: _propTypes.number
  }),
  id: _propTypes.string
};
TimePicker.defaultProps = {
  GA: {
    action: '',
    category: ''
  },
  overlayWidth: '250px',
  inputWidth: '100px',
  stepMinutes: 1,
  stepHours: 1,
  isDurationPicker: false,
  isDurationMinsOnly: false,
  tickOverEnabled: false,
  minMinutes: 0,
  maxMinutes: 59,
  minHours: 0,
  maxHours: 23,
  name: '',
  minTime: undefined,
  maxTime: undefined,
  id: ''
};

var _default = (0, _reactOnclickoutside.default)(TimePicker);

exports.default = _default;